import { render, staticRenderFns } from "./platfromitem.vue?vue&type=template&id=0cf26d29&scoped=true&"
import script from "./platfromitem.vue?vue&type=script&lang=js&"
export * from "./platfromitem.vue?vue&type=script&lang=js&"
import style0 from "./platfromitem.vue?vue&type=style&index=0&id=0cf26d29&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf26d29",
  null
  
)

export default component.exports